import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import request from "@/utils/request";
import { EventBus } from "@/api/event-bus";
export default {
  name: "Weforsystabledragg",
  props: {
    cityOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    icon: {
      type: String,
      default: "el-icon-setting"
    },
    type: {
      type: String,
      default: "primary"
    },
    reftext: {
      type: String,
      default: "multipleTables"
    },
    titletext: {
      type: String,
      default: "明细表单记忆设置"
    },
    transvalue: {
      type: String,
      default: ""
    },
    appendtobody: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      lists: [],
      visible: false,
      checkAll: false,
      checkedCities: [],
      cities: this.cityOptions,
      isIndeterminate: true,
      loadingbut: false,
      columnWidthlist: null
    };
  },
  watch: {},
  computed: {},
  created: function created() {
    var _this = this;
    console.log(this.reftext, "this.reftext111111");
    EventBus.$on("customEvents", function (data) {
      _this.columnWidthlist = data.message;
      _this.lists = _this.columnWidthlist;
      _this.columnWidthlist.forEach(function (element) {
        element.number = "";
      });
      _this.lists = JSON.parse(JSON.stringify(_this.columnWidthlist));
      _this.lists.forEach(function (element, index) {
        if (element.Index == "true") {
          _this.$nextTick(function () {
            if (_this.$refs[_this.reftext] != undefined) {
              _this.$refs[_this.reftext].$children[0].toggleRowSelection(element, true);
            }
          });
        }
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    EventBus.$off("customEvents");
  },
  methods: {
    resetform: function resetform() {
      var _this2 = this;
      this.$confirm("此操作将重置表单, 是否继续?", "提示", {
        type: "warning"
      }).then(function () {
        request({
          url: "/api/WMS/TableAdjustmentConfig/SetTableAdjustmentConfig",
          method: "post",
          data: {
            pageType: _this2.transvalue,
            pageConfig: []
          }
        }).then(function (res) {
          _this2.$message({
            message: res.msg,
            type: "success",
            duration: 1000
          });
          window.location.reload();
        });
      });
    },
    directaccess: function directaccess(row, index) {
      var _this3 = this;
      var rowlist = JSON.parse(JSON.stringify(row));
      console.log(rowlist, "rowlist");
      if (Number(rowlist.number) != 0 && rowlist.number != "" && rowlist.number != undefined) {
        var arrlist = JSON.parse(JSON.stringify(rowlist));
        var qulist = [];
        this.lists.splice(index, 1);
        if (Number(rowlist.number) > this.lists.length) {
          this.lists.push(arrlist);
          console.log("111111");
        } else {
          this.lists.forEach(function (element, idx) {
            if (idx + 1 == Number(rowlist.number)) {
              qulist.push(arrlist);
              qulist.push(element);
            } else {
              qulist.push(element);
            }
          });
          this.lists = qulist;
        }
        this.lists.forEach(function (element) {
          if (element.Index == true) {
            _this3.$nextTick(function () {
              if (_this3.$refs[_this3.reftext] && _this3.$refs[_this3.reftext].$children[0]) {
                _this3.$refs[_this3.reftext].$children[0].toggleRowSelection(element, true);
              }
            });
          }
        });

        // 操作完成后清空所有文本框
        this.$nextTick(function () {
          _this3.clearAllNumberInputs();
        });
      }
    },
    // 清空所有文本框
    clearAllNumberInputs: function clearAllNumberInputs() {
      var _this4 = this;
      this.lists.forEach(function (item, index) {
        // 使用$set确保Vue能正确响应数据变化
        _this4.$set(item, 'number', '');
      });
    },
    // 处理数字输入，确保只能输入大于0的数字
    handleNumberInput: function handleNumberInput(row) {
      // 转换为字符串进行处理（即使值为空也进行处理）
      var value = String(row.number || '');

      // 移除非数字字符
      value = value.replace(/[^0-9]/g, '');

      // 确保不是0开头的数字
      if (value.startsWith('0') && value.length > 1) {
        value = value.substring(1);
      }

      // 确保值不是0
      if (value === '0') {
        row.number = '';
        return;
      }

      // 设置值
      row.number = value || '';
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.lists.forEach(function (element) {
        element.Index = false;
        val.forEach(function (elementli) {
          if (element.Columns == elementli.Columns) {
            element.Index = true;
          }
        });
      });
    },
    moveUp: function moveUp(index, items) {
      if (index > 0) {
        var upItem = items[index - 1];
        items.splice(index - 1, 1, items[index]);
        items.splice(index, 1, upItem);
      }
    },
    moveDown: function moveDown(index, items) {
      if (index < items.length - 1) {
        var downItem = items[index + 1];
        items.splice(index + 1, 1, items[index]);
        items.splice(index, 1, downItem);
      }
    },
    select: function select() {
      var _this5 = this;
      this.lists.forEach(function (element) {
        element.Width = Number(element.Width);
      });
      request({
        url: "/api/WMS/TableAdjustmentConfig/SetTableAdjustmentConfig",
        method: "post",
        data: {
          pageType: this.transvalue,
          pageConfig: this.lists
        }
      }).then(function (res) {
        _this5.visible = false;
        _this5.$message({
          message: res.msg,
          type: "success",
          duration: 1000
        });
        window.location.reload();
      });
    },
    openDialog: function openDialog() {
      this.visible = true;
      EventBus.$emit("executeMethod");
    }
  }
};